module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: [_vm.prefixCls + '-item-group']
  }, [_c('div', {
    class: [_vm.prefixCls + '-item-group-title']
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a04663d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/menu/menu-group.vue
// module id = 647
// module chunks = 1